export default "__VITE_ASSET__DMMB20y8__"